import { Component, computed, inject, input, signal, viewChild } from '@angular/core';
import { NbDialogService } from '@nebular/theme';
import { InspectionFormWrapper } from '../inspection-form';
import { InspectionDetailDto } from '@artemis-software/wr-api';
import {
  MultiAttachmentControlComponent,
} from '@shared/form-controls/attachment-upload/multi-attachment-control/multi-attachment-control.component';
import { Attachment } from '@shared/form-controls/attachment-upload/attachment-utils';
import {
  ReassignSectionDialogComponent,
} from '@components/dialog/reassign-section-dialog/reassign-section-dialog.component';

@Component({
  standalone: false,
  selector: 'wr-archive-tab',
  templateUrl: './archive-tab.component.html',
  styleUrls: ['./archive-tab.component.scss'],
})
export class ArchiveTabComponent {

  private readonly dialogService = inject(NbDialogService);

  readonly formWrapper = input.required<InspectionFormWrapper>();
  readonly inspection = input.required<InspectionDetailDto>();

  readonly multiAttachmentControl = viewChild(MultiAttachmentControlComponent);

  readonly selectedSectionId = signal<string | null>(null);

  readonly sections = computed(() => {
    return this.inspection().building.sections ?? [];
  });

  get hasAnyPendingAttachments(): boolean {
    return this.multiAttachmentControl()?.hasAnyPendingAttachments ?? false;
  }

  onScopeChange(sectionId: string): void {
    this.selectedSectionId.set(sectionId === '' ? null : sectionId);
  }

  reassignFiles(): void {
    const ctrl = this.multiAttachmentControl();
    if (!ctrl || ctrl.selectedFiles.length === 0) return;

    this.dialogService.open(ReassignSectionDialogComponent, {
      context: {
        sections: this.sections(),
        count: ctrl.selectedFiles.length,
      },
    }).onClose.subscribe((targetSectionId: string | null | undefined) => {
      if (targetSectionId === undefined) return;
      ctrl.value = [...ctrl.value!.map((attachment, index) => {
        if (!ctrl.selectedFiles.includes(index)) return attachment;
        return { ...attachment, buildingSectionId: targetSectionId } as Attachment;
      })];
      ctrl.deselectAll();
    });
  }
}
